module.exports = __webpack_public_path__ + "static/media/Img_home_samii.33b51051.jpg";